import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MealModel } from 'src/app/nutrigenic/models/home/meal-model';
import { PlanService } from 'src/app/nutrigenic/services/plan/plan.service';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { NgxSpinnerService } from 'ngx-spinner';
import {ResizeDetectionService} from "../../services/resize-detection.service";

@Component({
    selector: 'app-current-menu',
    templateUrl: './current-menu.component.html',
    styleUrls: ['./current-menu.component.scss'],
})
export class CurrentMenuComponent {
    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;

    loading: boolean = true;
    filteredMeals: MealModel[] = [];
    visualMeals:MealModel[] = [];
    allMeals:any = [];

    constructor(private route: ActivatedRoute,
        private sizedetection: ResizeDetectionService,
        private planService: PlanService,
        private spinner: NgxSpinnerService
    ) {}
    

    ngOnInit() {

        // Size Detection
        this.sizedetection.refreshSize();
        this.sizedetection.sizeCondition$.subscribe(data => {
            this.isDesktop = data.isDesktop;
            this.isTablet = data.isTablet;
            this.isMobile = data.isMobile;
        });

        this.route.queryParams.subscribe(params => {
            let allergies = params["allergies"] ? params["allergies"] : [];
            this.getMeals({exclude_allergies_ids: JSON.stringify(allergies)});
            
        });
        
    }

    getMeals(query:any) {
        this.allMeals = [];
        this.visualMeals = [];
        this.spinner.show('mealsSpinner');

        this.planService.getMeals(query).subscribe({
            
            next: (meals: MealModel[]) => {
                this.filteredMeals = meals;

                let new_meals:any = [];
                let sel_meals1:any = [];
                let sel_meals2:any = [];
                let sel_meals3:any = [];
                let sel_meals4:any = [];

                this.filteredMeals.forEach((meal:any) => {
                    let new_meal:any = {};
                    new_meal.id = meal.id;
                    new_meal.name = meal.name;
                    new_meal.description = meal.description;
                    new_meal.type = meal.type;
                    new_meal.is_master_meal = meal.is_master_meal;
                    new_meal.photo_path = meal.photo_path;
                    new_meal.energyKcal = meal.energyKcal;
                    new_meal.protein = meal.protein;
                    new_meal.fat = meal.fat;
                    new_meal.availableCarbohydrate = meal.availableCarbohydrate;
                    new_meal.sugars = meal.sugars;
                    new_meal.sodium = meal.sodium;
                    new_meal.salt = meal.salt;
                    new_meal.categoryId = meal.categoryId;
                    new_meal.categoryKey = meal.categoryKey;
                    new_meal.categoryName = meal.categoryName;
                    new_meal.categories = meal.categories;
                    new_meal.categories_meals = meal.categories_meals;
                    new_meal.labels = meal.labels;
                    new_meal.alergies = meal.alergies;
                    new_meal.quid = meal.quid;
                    new_meal.price = meal.price;
                    new_meal.week = 1;
                    new_meal.count = 1;
                    new_meal.isAdded = false;
                    new_meal.show_nutrients = true;
                    if (new_meal.categories.map((x:any)=>x.id).includes(2)) {
                        sel_meals1.push(new_meal);
                    }
                    if (new_meal.categories.map((x:any)=>x.id).includes(4)) {
                        sel_meals2.push(new_meal);
                    }
                    if (new_meal.categories.map((x:any)=>x.id).includes(3)) {
                        sel_meals3.push(new_meal);
                    }
                    if (new_meal.categories.map((x:any)=>x.id).includes(9)) {
                        sel_meals4.push(new_meal);
                    }
                    new_meals.push(new_meal);
                });

                this.allMeals = new_meals;

                this.visualMeals = this.allMeals;

                this.loading = false;
                this.spinner.hide('mealsSpinner');
            },
            error: (error) => {
                this.spinner.hide('mealsSpinner');
                this.handleError(error); 
            }
        });
    }

    onMealsSearchChange(filteredMeals: MealModel[]){
        this.updateMealsOnPage(filteredMeals);
    }


    resetSearch() {
        this.updateMealsOnPage();
    }

    updateMealsOnPage(mealsToUpdate: MealModel[] = this.allMeals){
        this.visualMeals = JSON.parse(JSON.stringify(mealsToUpdate)); // deep cloning the list // reset the meals to original list so that i can apply the changes from oneWeekMeals
    }

    handleError(error: any): void {
        error = error.message ?? 'Internal error - Could not complete the operation';
        Notify.failure(error, {
            position: 'right-top',
            timeout: 3000
        });
            
    }
}